import type { ReactElement } from "react";
import { CheckCircle2, Circle } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger } from "../../../../shared/components/ui/select";

interface StatusSelectProps {
  readonly value: boolean;
  readonly onChange: (published: boolean) => void;
  readonly disabled?: boolean;
}

/**
 * Select component for title published status
 * Replaces the Switch with a more explicit dropdown
 */
export function StatusSelect({ value, onChange, disabled }: Readonly<StatusSelectProps>): ReactElement {
  const handleValueChange = (newValue: string) => {
    onChange(newValue === "published");
  };

  return (
    <Select value={value ? "published" : "draft"} onValueChange={handleValueChange} disabled={disabled}>
      <SelectTrigger className="w-[110px] h-8">
        <div className="flex items-center gap-2">
          {value ? (
            <>
              <CheckCircle2 className="h-3.5 w-3.5 text-green-400" />
              <span className="text-green-400 text-xs text-center font-medium">Published</span>
            </>
          ) : (
            <>
              <Circle className="h-3.5 w-3.5 text-yellow-400" />
              <span className="text-yellow-400 text-xs text-center font-medium">Draft</span>
            </>
          )}
        </div>
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="published">
          <div className="flex items-center gap-2">
            <CheckCircle2 className="h-3.5 w-3.5 text-green-400 text-center" />
            <span>Published</span>
          </div>
        </SelectItem>
        <SelectItem value="draft">
          <div className="flex items-center gap-2">
            <Circle className="h-3.5 w-3.5 text-yellow-400 text-center" />
            <span>Draft</span>
          </div>
        </SelectItem>
      </SelectContent>
    </Select>
  );
}
